// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-create-application-documentation) {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.checkbox-column {
  display: inline-block;
  width: 30%;
}

.required-document-label {
  font-size: 14px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 20px;
  color: #055C8D;
}

.upload-required-document-label {
  font-size: 12x;
  text-align: left;
  font-weight: 400;
  margin-bottom: 20px;
  color: #4a4a4a;
}

.required-document-label {
  font-size: 1rem;
  text-align: left;
  font-weight: 500;
  margin-bottom: 20px;
  margin-left: 10px;
  color: #053551;
}

.row-margins {
  margin-bottom: 5px;
  margin-top: 5px;
}

.justify-content-end {
  margin-left: 2%;
}

.last-row {
  margin-top: 5px;
  margin-bottom: 5px;
  padding-right: 0px;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.custom-checkbox > [type=checkbox]:disabled + label {
  cursor: not-allowed;
  font-weight: 600;
  color: #4a4a4a;
}

.custom-checkbox > [type=checkbox]:disabled:not(:checked) + label:before, .custom-checkbox > [type=checkbox]:disabled:checked + label:before {
  box-shadow: none;
  background-color: #f3f3f3;
  border-color: #f3f3f3;
  cursor: not-allowed;
  opacity: 1;
  font-family: "FontAwesome";
  content: "\\f00d";
  color: #4a4a4a;
}

.table-height {
  height: 40vh;
}

.view-link {
  vertical-align: middle;
}

.link-text {
  padding: 0 5px 0 2px;
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
